import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import SearchIcon from "@material-ui/icons/Search";
import FormControl from "@material-ui/core/FormControl";
import InputBase from "@material-ui/core/InputBase";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import { REQ_BY } from "../../store/types";
import {
  searchInvestors,
  getInvestors,
  getInvestorDetails,
  checkKyc,
  clearingFirstTimeInvestorJourney
} from "../../store/actions";
import { KycNotDoneDialog } from "./customModal";

export const NEW_TRANSACTION_URL = `/new-transaction`;
class Search extends Component {
  constructor(props) {
    super(props);
    const { tran_enable_flag } = this.props;
    this.state = {
      radioValue: tran_enable_flag === "Y" ? "pan" : "pan",
      inputValue: "",
      errorMessage: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { inputValue } = prevState;
    if (!this.state.inputValue && !!inputValue) {
      this.props.getInvestors({
        ARN: this.props.token,
        customfund: "189",
        AllFavFlag: "A",
        // AllFavFlag: this.props.selectedTab,
      });
    }
  }

  handleChange = (event) => {
    this.setState({
      radioValue: event.target.value,
      inputValue: "",
      errorMessage: "",
    });
  };

  changeInput = (event) => {
    const inputValue = event.target.value;
    if (inputValue === "") {
      this.setState({
        errorMessage: "",
      });
    }
    if (this.state.radioValue === "pan") {
      const pattern = /^[a-zA-Z0-9]*$/;
      if (pattern.test(inputValue)) {
        this.setState({
          inputValue: inputValue.toUpperCase(),
        });
      }
    }
    if (this.state.radioValue !== "pan") {
      this.setState({
        inputValue:
          this.state.radioValue === "mobile" && inputValue.length > 10
            ? this.state.inputValue
            : inputValue,
      });
    }

    // if (this.state.radioValue === "name" && inputValue.length >= 4) {
    //   this.search();
    // }
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.search();
      e.preventDefault();
    }
  };

  search = async () => {
    const { inputValue, radioValue } = this.state;
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (
      radioValue === "pan" &&
      (/[A-Za-z]{5}\d{4}[A-Za-z]{1}/.test(inputValue) === false ||
        inputValue === "")
    ) {
      this.setState({
        errorMessage: "Please enter a valid PAN",
      });
    } else if (radioValue === "name" && !inputValue) {
      this.setState({
        errorMessage: "Please enter a valid Name",
      });
    } else if (radioValue === "folio" && !inputValue) {
      this.setState({
        errorMessage: "Please enter a valid Folio Number",
      });
    } else if (
      radioValue === "mobile" &&
      (/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(inputValue) ===
        false ||
        inputValue === "")
    ) {
      this.setState({
        errorMessage: "Please enter a valid Mobile number",
      });
    } else if (
      radioValue === "email" &&
      (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(inputValue) ===
        false ||
        inputValue === "")
    ) {
      this.setState({
        errorMessage: "Please enter an valid Email Id",
      });
    } else {
      if (!!this.state.inputValue) {
        const x = {
          [this.state.radioValue]:
            this.state.radioValue === "pan"
              ? this.state.inputValue.toUpperCase()
              : this.state.inputValue,
          agent: this.props.token,
          uid: this.props.userId,
        };
        const response = await this.props.searchInvestors(
          {
            [this.state.radioValue]:
              this.state.radioValue === "pan"
                ? this.state.inputValue.toUpperCase()
                : this.state.inputValue,
            agent: this.props.token,
            uid: this.props.userId,
            customfund: "189",
          },
          true
        );
        if (!response && this.state.radioValue === "pan") {
          const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
          if (!this.state.inputValue || !regpan.test(this.state.inputValue)) {
            this.setState({
              errorMessage: "Please enter a valid PAN to proceed",
            });
          }
          // else if (this.state.inputValue.charAt(3) !== "P") {
          //   this.setState({
          //     errorMessage: "Non Indivdual PAN is not allowed to transact",
          //   });
          // }
          else {
            const params = {
              Uid: this.props.userId,
              ReqBy: REQ_BY,
              PAN: this.state.inputValue.toUpperCase(),
              customfund: "189",
            };

            const response = await this.props.getInvestorDetails(params, true);
            await this.props.clearingFirstTimeInvestorJourney();
            if (response) {
              this.setState({
                errorMessage: "",
              });
              // this.props.history.push({
              //   pathname: NEW_TRANSACTION_URL + "/transction-types",
              //   pan: this.state.inputValue
              // });
            } else {
              const kycResponse = await this.props.checkKyc(
                {
                  fund: "189",
                  userid: this.props.userId,
                  i_pan: this.state.inputValue,
                },
                true
              );

              const {
                DtData: [info],
              } = kycResponse;
              if (info.KYCBlock === "N") {
                await this.props.clearingFirstTimeInvestorJourney();
                this.props.history.push({
                  pathname: "new-investor-transaction/investor-details",
                  state: {
                    pan: !!this.state.inputValue ? this.state.inputValue : "",
                  },
                });
              } else {
                this.setState({ openModal: true });
              }
            }
          }
        }
      }
    }
  };
  closeModal = () => {
    this.setState({
      openModal: false,
    });
  };

  continue = () => {
    this.closeModal();
    this.props.history.push({
      pathname:
        NEW_TRANSACTION_URL,
    });
  };

  render() {
    const { count } = this.props;

    return (
      <div>
        {count === 0 && (
          <Paper
            className="investor-paper"
            style={{
              boxShadow: "0px 1px 3px 0px lavender",
              marginBottom: 20,
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
              <div className="investor-search-by">Search by:</div>
              <div
                style={{
                  borderRight: "2px solid #e7e8e9",
                  flexGrow: 1,
                }}
              >
                <RadioGroup
                  aria-label="Search"
                  name="search"
                  value={this.state.radioValue}
                  style={{
                    flexDirection: "row",
                  }}
                  className="radio-buttons-group"
                  onChange={this.handleChange}
                >
                  {/* {
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="name"
                          control={
                            <Radio
                              disabled={
                                this.props.tran_enable_flag === "Y"
                                  ? true
                                  : false
                              }
                              className="investor-search-radio"
                              style={{ color: "#005DAC" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">Name</div>
                      </div>
                    } */}
                  <div className="investor-radio-button">
                    <FormControlLabel
                      value="pan"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">PAN</div>
                  </div>
                  <div className="investor-radio-button">
                    <FormControlLabel
                      value="folio"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">Folio No.</div>
                  </div>
                  <div className="investor-radio-button">
                    <FormControlLabel
                      value="mobile"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">Mobile No.</div>
                  </div>
                  <div className="investor-radio-button">
                    <FormControlLabel
                      value="email"
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#005DAC" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                    <div className="investor-form-label">Email ID</div>
                  </div>
                </RadioGroup>
              </div>
            </div>
            <div style={{ display: "flex", flexGrow: 2 }}>
              <div className="investor-input-div">
                <SearchIcon className="investor-input-searchicon" />
                <InputBase
                  value={this.state.inputValue}
                  placeholder="Type here"
                  className="investor-input-inputbase"
                  inputProps={{
                    "aria-label": "Search",
                    maxLength: this.state.radioValue === "pan" ? "10" : "",
                    className: "investor-input-inputbase number-input",
                    type:
                      this.state.radioValue === "mobile" ||
                      this.state.radioValue === "folio"
                        ? "number"
                        : "",
                  }}
                  // inputRef={ele => (this.InputField = ele)}
                  onChange={this.changeInput}
                  onKeyPress={this.keyPress}
                  onKeyDown={(evt) =>
                    evt.key === "e" &&
                    (this.state.radioValue === "mobile" ||
                      this.state.radioValue === "folio") &&
                    evt.preventDefault()
                  }
                />
              </div>
              <div className="investor-search-button" onClick={this.search}>
                Search
              </div>
            </div>
          </Paper>
        )}
        {!!this.state.errorMessage ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              fontFamily: "Rubik-Italic",
              fontSize: 12,
              marginBottom: 10,
              color: "red",
            }}
          >
            {this.state.errorMessage}
          </div>
        ) : (
          ""
        )}
        <KycNotDoneDialog
          open={this.state.openModal}
          close={this.closeModal}
          continue={this.continue}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, investor, loading }) => {
    const { token, userId, tran_enable_flag } = authReducer;
    const { count } = loading;
    const { selectedTab } = investor;
    return { token, userId, selectedTab, count, tran_enable_flag };
  },
  { searchInvestors, getInvestors, getInvestorDetails, checkKyc ,clearingFirstTimeInvestorJourney}
)(Search);
